import React from 'react';
import { Props as LayoutProps } from './SitemapLayout';
import { schema } from '../../Schema/SitemapSchema';

export type Props = {
	Layout: any;
};

export const SitemapContainer = (props: Props) => {
	const render = (props: Props) => {
		const Layout = props.Layout;
		const outgoingProps: LayoutProps = {
			schema,
		};
		const returnValue = <Layout {...outgoingProps} />;
		return returnValue;
	};
	const outerReturnValue = render(props);
	return outerReturnValue;
};
